<template>
  <!-- Navigasyon Sekmeleri -->
  <tab-navigation :tabs="tabs" :initialTab="route.query.tab || 'general'" @change-tab="handleTabChange">
    <template #right-content>
      <!-- Kaydet Butonu - integrations veya payment dışındaki tüm sekmeler için gösterilir -->
      <custom-button v-if="currentTab !== 'integrations' && currentTab !== 'payment' && currentTab !== 'suggestions'" @click="saveTabSettings" :button-text="t('general.save')" color="header" :isLoading="buttonLoading" :loading-text="t('general.saving')" size="sm"/>
    </template>
  </tab-navigation>

  <!-- Ana İçerik -->
  <main>
    <div class="layout-spacing">
      <component :is="currentTabComponent" ref="tabRef" @saving="(val) => buttonLoading = val"/>
    </div>
  </main>
</template>

<script setup>
// Core imports
import { ref, computed, markRaw, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useContentStore } from '@/stores/content'

// Component imports
import TabNavigation from '@/components/base/navigation/TabNavigation.vue'
import CustomButton from '@/components/base/buttons/VButton.vue'

// Settings tab components
import generalConfiguration from './components/general/index.vue'
import scheduleSettings from './components/daySelector/index.vue'
import settingsConfiguration from './components/configuration/index.vue'
import sourceConfiguration from './components/source/index.vue'
import integrations from '@/views/settings/components/integration/index.vue'
import payment from '@/views/settings/components/payment'
import suggestions from './components/suggestions/index.vue'

// Composables
const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const contentStore = useContentStore()

// Refs
const buttonLoading = ref(false) // Kaydet butonu yükleniyor durumu
const tabRef = ref(null) // Aktif sekme bileşeni referansı
const currentTab = ref(route.query.tab || 'general') // Mevcut sekme

const tabs = computed(() => [
  { name: 'general', label: t('settings.tab.general'), component: markRaw(generalConfiguration) },
  { name: 'schedule', label: t('settings.tab.schedule'), component: markRaw(scheduleSettings) },
  { name: 'settingsConfiguration', label: t('settings.tab.settingsConfiguration'), component: markRaw(settingsConfiguration) },
  { name: 'sourceConfiguration', label: t('settings.tab.sourceConfiguration'), component: markRaw(sourceConfiguration) },
  { name: 'integrations', label: t('settings.tab.integrations'), component: integrations },
  { name: 'payment', label: t('settings.tab.payment'), component: payment },
  { name: 'suggestions', label: 'İyileştirme Önerileri', component: markRaw(suggestions) },
])

const currentTabComponent = computed(() => {
  const tab = tabs.value.find(tab => tab.name === currentTab.value)
  return tab ? tab.component : null
})

// Sekme değişikliği işlemi
const handleTabChange = (tabName) => {
  // İçerikler sayfasına yönlendirme durumunda store temizliği yap
  if (tabName === 'contents') {
    goToContentPage()
    return
  }

  // Normal sekme değişikliği
  currentTab.value = tabName
  const newQuery = { ...route.query, tab: tabName }
  router.push({ query: newQuery })
}

// İçerikler sayfasına gitme fonksiyonu
const goToContentPage = () => {
  // Store'dan seçili içerik ID'sini temizle
  contentStore.clearSelectedContent()
  // İçerikler sayfasına yönlendir
  router.push({ path: '/content-moderator' })
}

// Ayarları kaydetme işlemi
const saveTabSettings = async () => {
  try {
    // Aktif sekme bileşeninde save metodu varsa çağır
    if (tabRef.value && typeof tabRef.value.save === 'function') {
      await tabRef.value.save()
    } else {
      console.warn(`Save method not found for tab: ${currentTab.value}`)
    }
  } catch (error) {
    console.error('Error saving settings:', error)
  }
}

watch(() => route.query.tab, (newTab) => {
  if (newTab) currentTab.value = newTab
  else currentTab.value = 'general'
})
</script>
